import { useQuery } from '@apollo/client';
import { graphql } from 'gql.tada';

const EnrollmentsQuery = graphql.persisted(
  "EnrollmentsQuery",
  graphql(`
    query EnrollmentsQuery($schoolYearId: ID!) {
      schoolYear(id: $schoolYearId) {
        id
        name
        slug
        reenrollmentOpen
        openEnrollmentOpen
        inquiryToken
        school {
          id
          name
          slug
          checklistEnrollmentOn
          gradeLevelsSetting {
            items {
              description
              order
            }
          }
        }
        familyEnrollments {
          id
          enrollmentKind
          state
          access
          accessSource
          canDelete
          inviteStatus
          studentCount
          isInquiry
          canQueueForInvite
          canSendInvite
          inviteToken
          queuedAt
          sentAt
          submittedAt
          approvedAt
          packetSentAt
          packetViewedAt
          packetSubmittedAt
          createdAt
          updatedAt
          reviewReasons
          paymentScheduleType
          checklist {
            id
            completedAt
            late
            progress { done total waitingOn }
          }
          invoices {
            id
            kind
            status
            dueDate
            amountCents
          }
          studentEnrollments {
            id
            state
            enrollmentKind
            gradeLevel
            person {
              id
              firstName
              lastName
            }
          }
          family {
            id
            name
            slug
            primaryContactEmail
            primaryContactPhone
            guardians {
              id
              isPrimary
              person {
                id
                firstName
                lastName
                email
                phone
              }
            }
          }
        }
        studentEnrollments {
          id
          enrollmentKind
          state
          gradeLevel
          needsReview
          createdAt
          updatedAt
          person {
            id
            firstName
            lastName
          }
          familyEnrollment {
            id
            state
            access
            family {
              id
              name
              slug
            }
          }
        }
        admissionInquiries {
          id
          parentFirstName
          parentLastName
          parentEmail
          parentPhone
          numStudents
          state
          source
          metadataJson
          adminNotes
          createdAt
          family {
            id
            slug
          }
          familyEnrollment {
            id
            family {
              id
              slug
            }
          }
        }
      }
    }
  `)
);

export { EnrollmentsQuery };

export function useEnrollmentsQuery(schoolYearId: string | undefined) {
  return useQuery(EnrollmentsQuery, {
    variables: { schoolYearId: schoolYearId! },
    skip: !schoolYearId,
  });
}
